import { useTranslation } from 'react-i18next';

import {
  companiesFilterOptionsState,
  selectedCompaniesFiltersState,
} from '@/features/companies/companies.state';
import { isDefaultOptionArray } from '@/helpers/other';
import { AsyncSelect } from '@/ui/select/async/async-select';
import { sharedProps } from '@/ui/select/select-shared';
import { useAtom, useAtomValue } from 'jotai';

export const ListingStatusFilter = ({ className }: { className?: string }) => {
  const { t } = useTranslation('companies');

  const companiesFilters = useAtomValue(companiesFilterOptionsState);

  const [selectedFilters, setSelectedFilters] = useAtom(
    selectedCompaniesFiltersState,
  );

  const setOptions = async (search: string) => {
    if (search && companiesFilters.listingStatuses) {
      return companiesFilters.listingStatuses.filter(item =>
        item.label.toLowerCase().includes(search.toLowerCase()),
      );
    }

    return companiesFilters.listingStatuses;
  };

  return (
    <AsyncSelect
      id="filter-listing-stage"
      label={t`companies.filters.stage`}
      defaultValue={selectedFilters.listingStatuses}
      isMulti
      isSearchable
      className={className}
      setOptions={setOptions}
      onChange={option => {
        if (!isDefaultOptionArray(option)) return;
        setSelectedFilters(currentFilters => ({
          ...currentFilters,
          listingStatuses: option.length ? option : null,
        }));
      }}
      {...sharedProps}
    />
  );
};
